import React, { useMemo } from 'react';
import { portalDs } from 'src/components/portal-design-system';
import { cn } from 'src/lib/utils';
import ExclusionListSection from '../components/settings/exclusion-list-section';
import { useGetClientExclusionsQuery } from '../endpoints/client-exclusions.endpoints';

const SettingsTab: React.FC = () => {
  const { data: exclusions = [], isLoading } = useGetClientExclusionsQuery();

  const domainEntries = useMemo(
    () => exclusions.filter((entry) => entry.type === 'domain'),
    [exclusions]
  );
  const appEntries = useMemo(
    () => exclusions.filter((entry) => entry.type === 'app'),
    [exclusions]
  );

  return (
    <div className={cn(portalDs.page, 'h-full overflow-y-auto px-6 py-8 sm:px-10')}>
      <div className="mx-auto flex w-full max-w-3xl flex-col gap-6">
        <div>
          <h1 className="text-[20px] font-semibold tracking-[-0.02em] text-[#0D0F1A]">
            Settings
          </h1>
          <p className="mt-1 text-[14px] text-[#5E6278]">
            Global client report settings. Excluded domains and apps are hidden from client-facing
            report dashboards (new and legacy reporters).
          </p>
        </div>

        <ExclusionListSection
          title="Excluded Domains"
          type="domain"
          entries={domainEntries}
          isLoading={isLoading}
        />
        <ExclusionListSection
          title="Excluded Apps"
          type="app"
          entries={appEntries}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
};

export default SettingsTab;
